import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'
import { useTheme } from '@mui/material/styles'
import { SortingDirection } from 'sorting'
import { SVGIconProps } from 'commonTypes'

type SortingIconProps = {
    backgroundColor?: string
    color?: string
    direction?: SortingDirection
} & SVGIconProps

const SortIcon: React.FC<SortingIconProps> = ({
    backgroundColor,
    color,
    direction,
    ...props
}: SortingIconProps) => {
    const theme = useTheme()
    const defaultBackgroundColor = '#9B9B9B'
    const defaultColor = theme.palette.primary.main

    return (
        <SvgIcon viewBox="0 0 12 12" {...props}>
            <g
                id="Page-1"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g
                    id="sort-icon-gray"
                    transform="translate(0.000000, -1.000000)"
                >
                    <rect id="Rectangle" x="0" y="0"></rect>
                    <g
                        id="Icons"
                        transform="translate(0.000000, 1.000000)"
                        fillRule="nonzero"
                        fill={defaultBackgroundColor ?? backgroundColor}
                    >
                        <g
                            id="icon-sort-arrow-up@3x"
                            transform="translate(7.000000, 0.000000)"
                            fill={
                                direction === 'ASC'
                                    ? color ?? defaultColor
                                    : backgroundColor ?? defaultBackgroundColor
                            }
                        >
                            <path
                                d="M0.197581395,1.90674419 L1.93037209,0.174418605 C2.12795349,-0.0231627907 2.43046512,-0.0231627907 2.62804651,0.174418605 L4.36037209,1.90674419 C4.61609302,2.16246512 4.58111628,2.6044186 4.26725814,2.81381395 C4.0347,2.96506977 3.70902558,2.91828372 3.51144419,2.7207 L2.86009535,2.06935116 L2.86009535,9.37179302 C2.86009535,9.69746744 2.59256047,9.96500233 2.26688605,9.96500233 C1.94121163,9.96500233 1.67367674,9.69746744 1.67367674,9.37179302 L1.67413105,2.08121163 L1.04641012,2.72074651 C0.848828721,2.91832791 0.534968256,2.9651186 0.290596163,2.81386047 C-0.0232643023,2.60446512 -0.0582410465,2.16296512 0.197482209,1.9067907 L0.197581395,1.90674419 Z"
                                id="icon-sort-arrow-up"
                            ></path>
                        </g>
                        <g
                            id="icon-sort-arrow-down@3x"
                            fill={
                                direction === 'DESC'
                                    ? color ?? defaultColor
                                    : backgroundColor ?? defaultBackgroundColor
                            }
                        >
                            <path
                                d="M2.37188372,9.8255814 C2.56946512,10.0231628 2.87197674,10.0231628 3.06955814,9.8255814 L4.80188372,8.09325581 C5.0576047,7.83753488 5.0226279,7.3955814 4.70876977,7.18618605 C4.47621163,7.03493023 4.15053721,7.08171628 3.95295581,7.2793 L3.30160698,7.93064884 L3.30206128,0.616462791 C3.30206128,0.290788372 3.0345264,0.0232534884 2.70885198,0.0232534884 C2.38317756,0.0232534884 2.11564267,0.290788372 2.11564267,0.616462791 L2.11564267,7.91890465 L1.46429384,7.26755581 C1.26671244,7.06997442 0.95285198,7.02318372 0.70847988,7.17444186 C0.38280547,7.38383721 0.35964267,7.8257907 0.61536593,8.08151163 L2.37188372,9.8255814 Z"
                                id="icon-sort-arrow-down"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    )
}

export default SortIcon
